import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";

const AddWorkShiftsModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
	Service,
}) => {
	const [formData, setFormData] = useState({
		name: "",
		timeFrom: "",
		timeTo: "",
		allowanceTime: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				name: item?.name,
				allowanceTime: item?.allowance_time,
				timeFrom: item?.time_from,
				timeTo: item?.time_to,
			});
		}
	}, [item]);

	const submit = (e) => {
		e.preventDefault();
		let data = {
			name: formData?.name,
			allowance_time: formData?.allowanceTime,
			time_from: formData?.timeFrom,
			time_to: formData?.timeTo,
		};

		setLoading(true);
		if (isAdd) {
			Service.create(data)
				?.then((res) => {
					if (res && res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			Service.update(formData?.id, data)
				?.then((res) => {
					if (res && res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={
				lang === "en" ? "en fade addDepartment" : "ar fade addDepartment"
			}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.work_shift}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>

						<Col md={6}>
							<AvField
								label={Translate[lang]?.name}
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name}
								onChange={(e) =>
									setFormData({ ...formData, name: e.target.value })
								}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.allowance_time}
								type="number"
								placeholder={Translate[lang]?.allowance_time}
								bsSize="lg"
								name="allowanceTime"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.allowanceTime}
								onChange={(e) =>
									setFormData({ ...formData, allowanceTime: e.target.value })
								}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.time_from}
								type="time"
								placeholder={Translate[lang]?.time_from}
								name="timeFrom"
								bsSize="lg"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.timeFrom}
								onChange={(e) =>
									setFormData({ ...formData, timeFrom: e.target.value })
								}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.time_to}
								type="time"
								placeholder={Translate[lang]?.time_to}
								bsSize="lg"
								name="timeTo"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.timeTo}
								onChange={(e) =>
									setFormData({ ...formData, timeTo: e.target.value })
								}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					{/* <Button onClick={setAddModal} variant="danger light">
            {Translate[lang]?.close}
            </Button> */}
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.work_shift}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddWorkShiftsModal;
